import React, { useState, useMemo, useCallback, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import http from "../../../http";
import Swal from "sweetalert2";
import "../../../imageUrl";
import { useQuery, useQueryClient } from "react-query";
import { productLang } from "../../../Components/language/pages/productLang";
import useLanguage from "../../../Components/language/useLanguage";
import Modal from "react-modal";
import "./Drugs.css";

// Skeleton loader component matching TM design
function ProductTableSkeleton() {
  return (
    <div style={{ borderTop: "1px solid #e9ecef" }}>
      {[...Array(5)].map((_, i) => (
        <div key={i} style={{ padding: "16px", borderBottom: "1px solid #e9ecef" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "4fr 2fr 2fr 1.5fr 1fr 1.5fr 1fr 2fr",
              gap: "16px",
              alignItems: "center"
            }}
          >
            {/* Product Column Skeleton */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  width: "96px",
                  height: "96px",
                  backgroundColor: "#e9ecef",
                  borderRadius: "8px",
                  flexShrink: 0,
                  animation: "pulse 1.5s ease-in-out infinite"
                }}
              ></div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    height: "20px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "4px",
                    width: "60%",
                    marginBottom: "8px",
                    animation: "pulse 1.5s ease-in-out infinite"
                  }}
                ></div>
                <div
                  style={{
                    height: "16px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "4px",
                    width: "40%",
                    marginBottom: "8px",
                    animation: "pulse 1.5s ease-in-out infinite"
                  }}
                ></div>
                <div
                  style={{
                    height: "24px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "4px",
                    width: "80px",
                    marginTop: "8px",
                    animation: "pulse 1.5s ease-in-out infinite"
                  }}
                ></div>
              </div>
            </div>
            {/* Price Column Skeleton */}
            <div
              style={{
                height: "20px",
                backgroundColor: "#e9ecef",
                borderRadius: "4px",
                width: "80px",
                animation: "pulse 1.5s ease-in-out infinite"
              }}
            ></div>
            {/* Channel MRP Column Skeleton */}
            <div
              style={{
                height: "36px",
                backgroundColor: "#e9ecef",
                borderRadius: "4px",
                width: "120px",
                animation: "pulse 1.5s ease-in-out infinite"
              }}
            ></div>
            {/* Category Column Skeleton */}
            <div
              style={{
                height: "16px",
                backgroundColor: "#e9ecef",
                borderRadius: "4px",
                width: "100px",
                animation: "pulse 1.5s ease-in-out infinite"
              }}
            ></div>
            {/* Stock Column Skeleton */}
            <div
              style={{
                height: "16px",
                backgroundColor: "#e9ecef",
                borderRadius: "4px",
                width: "50px",
                animation: "pulse 1.5s ease-in-out infinite"
              }}
            ></div>
            {/* Status Column Skeleton */}
            <div
              style={{
                height: "24px",
                backgroundColor: "#e9ecef",
                borderRadius: "12px",
                width: "44px",
                animation: "pulse 1.5s ease-in-out infinite"
              }}
            ></div>
            {/* Actions Column Skeleton */}
            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-start" }}>
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: "#e9ecef",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite"
                }}
              ></div>
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: "#e9ecef",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite"
                }}
              ></div>
            </div>
          </div>
        </div>
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}

// 🔹 Channel box er background color
const getChannelBgColor = (channelName = "") => {
  const name = channelName.toLowerCase();
  if (name.includes("daraz")) return "#f85506"; // Daraz orange
  if (name.includes("thaimart fb")) return "#39a1ff"; // Thaimart FB blue
 if (name.includes("thaimart")) return "#062579"; // Thaimart blue
  
  return "rgba(149, 157, 255, 0.1)"; // default light blue
};


function Drugs() {
  const lan = useLanguage(productLang);
  const queryClient = useQueryClient();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [zoomImage, setZoomImage] = useState(null);
  const [copiedSku, setCopiedSku] = useState(null);
  const searchTimeoutRef = useRef(null);
  const htmlCacheRef = useRef(new Map());
  const imageUrlCacheRef = useRef(new Map());
  const [statusMap, setStatusMap] = useState({});
  const tableGrid = "2.5fr 2fr 1.5fr  1fr 1fr 0.8fr 0.8fr";



  // Debounce search term
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    if (searchTerm !== debouncedSearchTerm) {
      setIsSearching(true);
    }
    searchTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setCurrentPage(1);
      setIsSearching(false);
    }, 500);
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchTerm, debouncedSearchTerm]);

  const { data, isLoading } = useQuery("drugs", () =>
    http.get(`/drugs`).then((res) => {
      return res.data?.data;
    })
  );
  useEffect(() => {
  if (data) {
    const map = {};
    data.forEach(item => {
      map[item.id] = item.status === "1" || item.status === 1 || item.status === true;
    });
    setStatusMap(map);
  }
}, [data]);
  

  // Memoized helper function to strip HTML tags with caching
  const stripHtmlTags = useCallback((html) => {
    if (!html) return '';
    if (htmlCacheRef.current.has(html)) {
      return htmlCacheRef.current.get(html);
    }
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    const result = tmp.textContent || tmp.innerText || '';
    htmlCacheRef.current.set(html, result);
    // Limit cache size to prevent memory issues
    if (htmlCacheRef.current.size > 1000) {
      const firstKey = htmlCacheRef.current.keys().next().value;
      htmlCacheRef.current.delete(firstKey);
    }
    return result;
  }, []);

  // Filter and paginate data with debounced search
  const filteredData = useMemo(() => {
    if (!data) return [];
    if (!debouncedSearchTerm) return data;
    
    const searchLower = debouncedSearchTerm.toLowerCase();
    return data.filter((item) => {
      // Quick checks first (no HTML parsing needed)
      if (item.macrohealth_sg?.toLowerCase().includes(searchLower)) return true;
      if (item.unit?.toLowerCase().includes(searchLower)) return true;
      if (item.generic_Name?.toLowerCase().includes(searchLower)) return true;
      if (item.generic_name?.toLowerCase().includes(searchLower)) return true;
      if (item.SKU?.toLowerCase().includes(searchLower)) return true;
      if (item.category?.toLowerCase().includes(searchLower)) return true;
      
      // Only parse HTML if other checks fail
      const descriptionText = stripHtmlTags(item.drug_description || '');
      return descriptionText.toLowerCase().includes(searchLower);
    });
  }, [data, debouncedSearchTerm, stripHtmlTags]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredData.slice(startIndex, startIndex + pageSize);
  }, [filteredData, currentPage, pageSize]);

  const totalPages = Math.ceil(filteredData.length / pageSize);

  const deleteRowData = useCallback(async (e, id) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: lan?.deleteConfirm || "Are you sure?",
      text: lan?.deleteText || "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: lan?.yes || "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const res = await http.delete(`/drugs/${id}`);
        if (res.data.status === 200) {
          queryClient.invalidateQueries("drugs");
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: lan?.deleted || "Deleted!",
            text: lan?.message || "Your file has been deleted.",
            timer: 2500,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete product",
        });
      }
    }
  }, [lan, queryClient]);

  const updateStatus = useCallback((row, newStatus) => {
    http.post(`/drugs/update/${row.id}`, {
      ...row,
      status: newStatus
    }).then((res) => {
      if (res.data.status === 200) {
        queryClient.invalidateQueries("drugs");
      }
    }).catch((err) => {
      console.error('Failed to update status:', err);
    });
  }, [queryClient]);

  // Memoized base image URL
  const baseImageUrl = useMemo(() => {
    const url = process.env.REACT_APP_DEV_MODE_IMAGE_URL || 
                process.env.REACT_APP_IMAGE_URL || 
                process.env.REACT_APP_PRO_MODE_IMAGE_URL || 
                'http://127.0.0.1:8001';
    return url.replace(/\/$/, '');
  }, []);

  // Memoized get image URL helper with caching
  const getImageUrl = useCallback((row) => {
    const cacheKey = `${row?.id}_${row?.main_image || ''}_${row?.image || ''}`;
    if (imageUrlCacheRef.current.has(cacheKey)) {
      return imageUrlCacheRef.current.get(cacheKey);
    }
    
    let imageFileName = row?.main_image || row?.image || '';
    
    if (!imageFileName || 
        imageFileName === 'null' || 
        imageFileName === 'undefined' || 
        imageFileName.trim() === '') {
      imageFileName = '';
    } else {
      imageFileName = imageFileName.replace(/^.*[\\\/]/, '');
      imageFileName = imageFileName.split('?')[0].split('#')[0].trim();
    }
    
    const result = imageFileName && imageFileName !== ''
      ? `${baseImageUrl}/files/drugs/${imageFileName}`
      : null;
    
    imageUrlCacheRef.current.set(cacheKey, result);
    // Limit cache size
    if (imageUrlCacheRef.current.size > 1000) {
      const firstKey = imageUrlCacheRef.current.keys().next().value;
      imageUrlCacheRef.current.delete(firstKey);
    }
    
    return result;
  }, [baseImageUrl]);

  const handleCopySku = useCallback(async (sku, productId) => {
    if (sku) {
      try {
        await navigator.clipboard.writeText(sku);
        setCopiedSku(productId);
        setTimeout(() => setCopiedSku(null), 2000);
      } catch (err) {
        console.error("Failed to copy SKU:", err);
      }
    }
  }, []);

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  return (
    <div className="page-content" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", padding: "24px" }}>
      {/* Header */}
      <div style={{ marginBottom: "24px", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "bold", color: "#343a40", margin: 0, fontFamily: "sans-serif" }}>
            Products List
          </h1>
          <p style={{ fontSize: "14px", color: "#6c757d", marginTop: "4px", marginBottom: 0, fontFamily: "sans-serif" }}>
            Manage your products, view details, and track inventory
          </p>
        </div>
        <Link
          to="/add-drugs"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            backgroundColor: "#4ade80",
            color: "white",
            padding: "8px 16px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            fontFamily: "sans-serif",
            transition: "background-color 0.2s"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#22c55e";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#4ade80";
          }}
        >
          <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          {lan?.addProduct || "Add New Product"}
        </Link>
      </div>

      {/* Search and Filters */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          border: "1px solid #e9ecef",
          padding: "16px",
          marginBottom: "24px"
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          style={{ display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }}
        >
          <input
            type="text"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: "1 1 200px",
              minWidth: "200px",
              padding: "8px 16px",
              border: "1px solid #e9ecef",
              borderRadius: "8px",
              fontSize: "14px",
              fontFamily: "sans-serif",
              outline: "none"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#a855f7";
              e.target.style.boxShadow = "0 0 0 2px rgba(168, 85, 247, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#e9ecef";
              e.target.style.boxShadow = "none";
            }}
          />
          {isSearching && (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                className="spinner-border spinner-border-sm"
                role="status"
                style={{ width: "16px", height: "16px", borderWidth: "2px", color: "#6c757d" }}
              >
                <span className="visually-hidden">Searching...</span>
              </div>
            </div>
          )}
        </form>
      </div>

      {/* Products List */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          border: "1px solid #e9ecef",
          overflow: "hidden"
        }}
      >
        {isLoading ? (
          <ProductTableSkeleton />
        ) : paginatedData.length === 0 ? (
          <div style={{ padding: "48px", textAlign: "center" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>📦</div>
            <p style={{ color: "#6c757d", fontFamily: "sans-serif", margin: 0 }}>No products found</p>
          </div>
        ) : (
          <>
            {/* Table Header */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e9ecef",
                padding: "12px 16px"
              }}
            >
              <div
              style={{
                display: "grid",
                gridTemplateColumns: tableGrid,

                gap: "16px",
                fontSize: "12px",
                fontWeight: "600",
                color: "#495057",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                fontFamily: "sans-serif"
              }}
            >
              <div>Product</div>
              
              <div>{lan?.mrpPrice || "MRP Price"}</div>
              <div>Category</div>
              <div>Stock</div>
              <div>Expiry Date</div> 
              <div>Status</div>
               
              <div>Actions</div>
            </div>
            </div>

            {/* Products List */}
            <div style={{ borderTop: "1px solid #e9ecef" }}>
              {paginatedData.map((product) => {
                const isActive = product?.status === "1" || product?.status === 1 || product?.status === true;
                const imageUrl = getImageUrl(product);
                
                return (
                  <div
                    key={product.id}
                    style={{
                      padding: "16px",
                      borderBottom: "1px solid #e9ecef",
                      transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: tableGrid,

                        gap: "16px",
                        alignItems: "center"
                      }}
                    >
                      {/* Product Column */}
                      <div>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          {/* Product Image */}
                          <div
                            style={{
                              position: "relative",
                              flexShrink: 0,
                              width: "96px",
                              height: "96px",
                              minWidth: "96px",
                              minHeight: "96px",
                              borderRadius: "8px",
                              overflow: "hidden",
                              border: "1px solid #e9ecef",
                              backgroundColor: "#f8f9fa",
                              aspectRatio: "1 / 1"
                            }}
                            className="product-image-group"
                          >
                            {imageUrl ? (
                              <>
                                <img
                                  src={imageUrl}
                                  alt={product.macrohealth_sg || "Product"}
                                  loading="lazy"
                                  className="drug-thumbnail-img"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    display: "block"
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    const placeholder = e.target.nextElementSibling;
                                    if (placeholder) {
                                      placeholder.style.display = 'flex';
                                    }
                                  }}
                                />
                                <button
                                  onClick={() => setZoomImage(imageUrl)}
                                  style={{
                                    position: "absolute",
                                    top: "4px",
                                    right: "4px",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    color: "white",
                                    padding: "6px",
                                    borderRadius: "50%",
                                    border: "none",
                                    cursor: "pointer",
                                    opacity: 0,
                                    transition: "opacity 0.2s",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "24px",
                                    height: "24px",
                                    zIndex: 10
                                  }}
                                  className="zoom-button"
                                  title="Zoom image"
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
                                  }}
                                >
                                  <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" />
                                  </svg>
                                </button>
                              </>
                            ) : null}
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "#f8f9fa",
                                display: imageUrl ? "none" : "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              <span style={{ fontSize: "32px" }}>📦</span>
                            </div>
                            <style>{`
                              .product-image-group:hover .zoom-button {
                                opacity: 1 !important;
                              }
                            `}</style>
                          </div>

                          {/* Product Name and Code */}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#343a40",
                                fontFamily: "sans-serif",
                                marginBottom: "4px",
                                display: "-webkit-box",       // multiline limit er jonno
      WebkitLineClamp: 3,           // max 3 lines
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis"
                              }}
                            >
                              {product.macrohealth_sg || "N/A"}
                            </div>
                            {product.SKU && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  fontSize: "14px",
                                  color: "#6c757d",
                                  fontFamily: "sans-serif"
                                }}
                              >
                                <span>Code: {product.SKU}</span>
                                <button
                                  onClick={() => handleCopySku(product.SKU, product.id)}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    color: "#6c757d",
                                    cursor: "pointer",
                                    padding: 0,
                                    display: "flex",
                                    alignItems: "center"
                                  }}
                                  title="Copy SKU"
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.color = "#343a40";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.color = "#6c757d";
                                  }}
                                >
                                  {copiedSku === product.id ? (
                                    <svg style={{ width: "16px", height: "16px" }} fill="currentColor" viewBox="0 0 20 20">
                                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                  </svg>
                                  ) : (
                                    <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                   </svg>
                                  )}
                                </button>
                              </div>
                            )}
                            {/* Generic Name Tag */}
                            {product.generic_name && (
                              <div style={{ marginTop: "8px" }}>
                                <span
                                  style={{
                                    padding: "4px 8px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    backgroundColor: "#e9ecef",
                                    color: "#495057",
                                    borderRadius: "4px",
                                    fontFamily: "sans-serif"
                                  }}
                                >
                                  {product.generic_name}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Expiry Date */}
<div
  style={{
    marginTop: "4px",
    fontSize: "14px",
    color: "#495057",
    fontFamily: "sans-serif"
  }}
>
  Expiry Date: {product.expiry_date ? product.expiry_date : "N/A"}
</div>


                      

                      {/* Channel MRP Column */}
                      <div>
                        {(() => {
                          const mrpList =
                            (product.channel_mrp_prices && product.channel_mrp_prices.length > 0
                              ? product.channel_mrp_prices
                              : product.mrp_prices) || [];

                          return mrpList.length > 0 ? (
                          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            {mrpList.map((ch, idx) => (
                              <div
                                key={ch.id != null ? ch.id : idx}
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                  padding: "8px 12px",
                                  borderRadius: "8px",
                                  backgroundColor: getChannelBgColor(ch.channel_name),

                                  border: "1px solid rgba(149, 157, 255, 0.25)",
                                  fontFamily: "sans-serif",
                                  lineHeight: "1.4",
                                  minWidth: "0"
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    color: 
  (ch.channel_name || "").toLowerCase().includes("daraz") || 
  (ch.channel_name || "").toLowerCase().includes("thaimart") || 
  (ch.channel_name || "").toLowerCase().includes("thaimart fb")
    ? "white"
    : "#959DFF",

                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  {ch.channel_name || "—"}
                                </span>
                                <span
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                     color: 
      (ch.channel_name || "").toLowerCase().includes("daraz") || 
      (ch.channel_name || "").toLowerCase().includes("thaimart") || 
      (ch.channel_name || "").toLowerCase().includes("thaimart fb")
        ? "white"
        : "#959DFF",
                                    flexShrink: 0
                                  }}
                                >
                                  ৳{parseFloat(ch.mrp_price || 0).toFixed(2)}
                                </span>
                              </div>
                            ))}
                          </div>
                          ) : (
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#cbd5e1",
                              fontFamily: "sans-serif",
                              fontStyle: "italic"
                            }}
                          >
                            No MRP set
                          </span>
                          );
                        })()}
                      </div>

                      {/* Category Column */}
                      <div>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#333",
                            fontFamily: "sans-serif"
                          

 
                          }}
                        >
                          {product.category 
                            ? (typeof product.category === 'string' 
                                ? product.category 
                                : product.category?.name || product.category?.category_name || 'N/A')
                            : product.category_name || 'N/A'}
                        </div>
                        {product.sub_category && (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#6c757d",
                              marginTop: "4px",
                              fontFamily: "sans-serif"
                            }}
                          >
                            {typeof product.sub_category === 'string' 
                              ? product.sub_category 
                              : product.sub_category?.name || product.sub_category?.sub_category_name || ''}
                          </div>
                        )}
                      </div>

                      {/* Stock Column */}
                      <div>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#495057",
                            fontFamily: "sans-serif"
                          }}
                        >
                          {product.Stock !== null && product.Stock !== undefined ? product.Stock : "N/A"}
                        </div>
                      </div>



                      {/* Status Column */}
<div>
  <label
    style={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      cursor: "pointer"
    }}
  >
    <input
      type="checkbox"
      checked={statusMap[product.id] || false} // statusMap use korchi
      onChange={(e) => {
        const newStatus = e.target.checked ? "1" : "0";

        // 1️⃣ Update backend
        updateStatus(product, newStatus);

        // 2️⃣ Update frontend instantly
        setStatusMap(prev => ({
          ...prev,
          [product.id]: e.target.checked
        }));
      }}
      style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
    />
    <div
      style={{
        width: "44px",
        height: "24px",
        borderRadius: "12px",
        backgroundColor: (statusMap[product.id] || false) ? "#22c55e" : "#d1d5db",
        transition: "background-color 0.3s",
        position: "relative"
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: "white",
          borderRadius: "50%",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          transform: (statusMap[product.id] || false) ? "translateX(20px)" : "translateX(2px)",
          transition: "transform 0.3s",
          position: "absolute",
          top: "2px"
        }}
      ></div>
    </div>
  </label>
</div>


                      
                      {/* Actions Column */}
                      <div>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <Link
                            to={`/edit-drugs/${product.id}`}
                            style={{
                              color: "#2196f3",
                              textDecoration: "none",
                              transition: "color 0.2s"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = "#1976d2";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = "#2196f3";
                            }}
                            title="Edit"
                          >
                            <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </Link>
                          <button
                            onClick={(e) => deleteRowData(e, product.id)}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#ef4444",
                              cursor: "pointer",
                              padding: 0,
                              transition: "color 0.2s"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = "#dc2626";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = "#ef4444";
                            }}
                            title="Delete"
                          >
                            <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "16px 24px",
                  borderTop: "1px solid #e9ecef",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}
              >
                <div style={{ fontSize: "14px", color: "#495057", fontFamily: "sans-serif" }}>
                  Showing {paginatedData.length} of {filteredData.length} products
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <button
                    onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1 || isLoading}
                    style={{
                      padding: "8px 16px",
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      backgroundColor: currentPage === 1 || isLoading ? "#f5f5f5" : "white",
                      cursor: currentPage === 1 || isLoading ? "not-allowed" : "pointer",
                      color: currentPage === 1 || isLoading ? "#999" : "#495057",
                      fontFamily: "sans-serif",
                      transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => {
                      if (currentPage !== 1 && !isLoading) {
                        e.currentTarget.style.backgroundColor = "#e9ecef";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (currentPage !== 1 && !isLoading) {
                        e.currentTarget.style.backgroundColor = "white";
                      }
                    }}
                  >
                    Previous
                  </button>
                  <span style={{ padding: "8px 16px", fontSize: "14px", color: "#495057", fontFamily: "sans-serif" }}>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages || isLoading}
                    style={{
                      padding: "8px 16px",
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      backgroundColor: currentPage === totalPages || isLoading ? "#f5f5f5" : "white",
                      cursor: currentPage === totalPages || isLoading ? "not-allowed" : "pointer",
                      color: currentPage === totalPages || isLoading ? "#999" : "#495057",
                      fontFamily: "sans-serif",
                      transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => {
                      if (currentPage !== totalPages && !isLoading) {
                        e.currentTarget.style.backgroundColor = "#e9ecef";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (currentPage !== totalPages && !isLoading) {
                        e.currentTarget.style.backgroundColor = "white";
                      }
                    }}
                  >
                    Next
                  </button>
                  <select
                    value={currentPage}
                    onChange={(e) => handlePageChange(Number(e.target.value))}
                    disabled={isLoading}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      fontSize: "14px",
                      color: "#495057",
                      backgroundColor: "white",
                      fontFamily: "sans-serif",
                      cursor: isLoading ? "not-allowed" : "pointer",
                      outline: "none"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#a855f7";
                      e.target.style.boxShadow = "0 0 0 2px rgba(168, 85, 247, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e9ecef";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <option key={page} value={page}>
                        {page}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Zoom Image Modal */}
      {zoomImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px"
          }}
          onClick={() => setZoomImage(null)}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 16px 16px 16px"
            }}
          >
            <button
              onClick={() => setZoomImage(null)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                backgroundColor: "white",
                color: "#333",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "background-color 0.2s",
                zIndex: 10
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e9ecef";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "white";
              }}
              title="Close"
            >
              <svg style={{ width: "24px", height: "24px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img
              src={zoomImage}
              alt="Zoomed product"
              className="drug-zoom-img"
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                width: "auto",
                height: "auto",
                objectFit: "contain",
                objectPosition: "center",
                borderRadius: "8px",
                display: "block"
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Drugs;
